module.exports = __webpack_public_path__ + "img/hamburger.7b69f46f.png";